import type { ReactNode } from "react";

import { HeadContent, Scripts } from "@tanstack/react-router";

export function ProductShell({ children }: { children: ReactNode }) {
  return (
    <>
      <HeadContent />
      <a
        data-site-skip
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[2147483001] focus:rounded-[3px] focus:border focus:border-foreground focus:bg-background focus:px-2.5 focus:py-1 focus:text-[12px] focus:text-foreground focus:no-underline focus:outline-2 focus:outline-offset-2 focus:outline-foreground"
      >
        Skip to main content
      </a>
      {children}
      <Scripts />
    </>
  );
}
